/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import {
  CREATE_DEVICE_TYPE,
  CREATE_DEVICE_TYPE_FAILURE,
  CREATE_DEVICE_TYPE_SUCCESS,
} from '../actions/analyticsEngineActionCreators';

export const analyticsEngineReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_DEVICE_TYPE:
      return {
        ...state,
        updatingData: true,
        updateDataError: undefined,
      };
    case CREATE_DEVICE_TYPE_FAILURE:
      return {
        ...state,
        updatingData: false,
        updateDataError: action.payload,
      };
    case CREATE_DEVICE_TYPE_SUCCESS:
      return {
        ...state,
        updatingData: false,
        updateDataError: undefined,
      };
    default:
      return state;
  }
};
